/* Local dependencies */
import { Service } from '../utils/types';
import {
  GetLocale,
  ListServices,
  ListServicesActionTypes,
  ListServicesError,
  ListServicesSuccess,
  PressService,
  RemoveSelectedService,
  ResetPressService,
  SelectService,
} from './types';

export function listServices(
  filter?: {},
  currentPage: number = 1,
  searchString: string = '',
  size: number = 20,
): ListServices {
  return {
    type: ListServicesActionTypes.LIST_SERVICES_REQUEST,
    filter,
    currentPage,
    searchString,
    size,
  };
}

export function listServicesSucceeded(total, services): ListServicesSuccess {
  return {
    type: ListServicesActionTypes.LIST_SERVICES_SUCCESS,
    services,
    total,
  };
}

export function listServicesFailed(error: Error): ListServicesError {
  return {
    type: ListServicesActionTypes.LIST_SERVICES_ERROR,
    error,
  };
}

export function sortServicesBy(field: string) {
  return {
    type: ListServicesActionTypes.SORT_SERVICES_BY,
    field,
  };
}

export function selectService(service: Service): SelectService {
  return {
    type: ListServicesActionTypes.SELECT_SERVICE,
    service,
  };
}

export function removeSelectedService(field: any): RemoveSelectedService {
  return {
    type: ListServicesActionTypes.REMOVE_SELECTED_SERVICE,
    field,
  };
}

export function resetSelectedService() {
  return {
    type: ListServicesActionTypes.RESET_SELECTED_SERVICE,
  };
}

export function resetServicesState() {
  return {
    type: ListServicesActionTypes.RESET_SERVICES_STATE,
  };
}

export function pressedService(service: Service): PressService {
  return {
    type: ListServicesActionTypes.PRESS_SERVICE,
    service,
  };
}

export function resetPressedService(): ResetPressService {
  return {
    type: ListServicesActionTypes.RESET_PRESS_SERVICE,
  };
}

export function getLocale(locale: string): GetLocale {
  return {
    type: ListServicesActionTypes.GET_LOCALE,
    locale,
  };
}
